import { isPlatformBrowser } from '@angular/common';
import { Component, Renderer2, OnInit, ElementRef, PLATFORM_ID, Inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'angularreferencedoc';
  navbarStatus: string = 'close';
  hotCornerClass!: string;
  showMenu: boolean = false;
  menuOpened: boolean = true;
  constructor(
    private _renderer: Renderer2,
    private _el: ElementRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    @Inject(PLATFORM_ID) public platformId: Object
  ) { 
    if (isPlatformBrowser(this.platformId)) {
        document.body.addEventListener('mousedown', function () {
        document.body.classList.remove('using-keyboard');
        document.body.classList.add('using-mouse');
      });
        document.body.addEventListener('keydown', function (event) {
        document.body.classList.remove('using-mouse');
        document.body.classList.add('using-keyboard');

      });
    }
  }

  ngOnInit() {
    

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('global-nav-demo') || event.url.includes('navigation-drawer') || event.url.includes('navigation-drawer-with-sub-child') || event.url.includes('toolbar') || event.url.includes('menubar') || event.url.includes('cascade-menubar')) {
          this.showMenu = false;
        }
        else {
          this.showMenu = true;
        }
      }
    })

    const el = this._el.nativeElement.querySelector('.wrapper');

    this.activatedRoute.queryParams.subscribe(params => {
      this.navbarStatus = params.navbar;
    });

    this.activatedRoute.queryParams.subscribe(params => {
      if (params && params['menuExpandCollapse']) {
        if (params['menuExpandCollapse'] == 'true') {
          this._renderer.addClass(el, 'open');
        } else {
          this._renderer.removeClass(el, 'open');
        }
      }

      if (params && params['hotCornerClass']) {
        this.hotCornerClass = params['hotCornerClass'];
      }
    });
  }

  getHotCorner(hotCornerClass: string) {
    this.hotCornerClass = hotCornerClass;
  }
}